class RetailerSearchForm extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.form = this.querySelector('form');
    this.input = this.querySelector('.find-retailer__input');
    this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
    this.input?.addEventListener('input', () => this.handleInput());
  }

  async handleInput() {
    const resultsMap = this.findResultsMap();
    if (!resultsMap) return;

    await customElements.whenDefined('retailer-map');
    resultsMap.filterRetailers(this.input?.value?.trim() || '');
  }

  async handleSubmit(event) {
    const resultsMap = this.findResultsMap();
    if (!resultsMap) return;

    event.preventDefault();
    await customElements.whenDefined('retailer-map');

    const query = this.input?.value?.trim() || '';
    resultsMap.filterRetailers(query);

    const resultsSection = resultsMap.closest('.retailer-results');
    resultsSection?.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  }

  findResultsMap() {
    const maps = Array.from(document.querySelectorAll('retailer-map'));
    const followingMap = maps.find((map) => Boolean(this.compareDocumentPosition(map) & Node.DOCUMENT_POSITION_FOLLOWING));
    return followingMap || maps[0] || null;
  }
}

if (!customElements.get('retailer-search-form')) {
  customElements.define('retailer-search-form', RetailerSearchForm);
}
